import type {
    ComponentChildren,
} from "preact";

type ProgressBarProps = {
    percent: number;
    colorClass?: string;
};

export const ProgressBar = ({
    percent,
    colorClass = "bg-accent",
}: ProgressBarProps): ComponentChildren => {
    return (
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-bg-tertiary">
            <div
                className={`h-full ${colorClass}`}
                style={{
                    width: `${Math.min(Math.max(percent, 0), 100)}%`,
                }}
            />
        </div>
    );
};
